import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../../styles/sidebar.css";
const SideBar = () => {
  const [openMenu, setOpenMenu] = useState(null);

  const toggleMenu = (menu) => {
    setOpenMenu(openMenu === menu ? null : menu);
  };

  return (
    <div className="d-flex">

      {/* SIDEBAR */}
      <div
        className="d-flex flex-column p-3 shadow-sm"
        style={{
          width: "260px",
          minHeight: "100vh",
          background: "linear-gradient(180deg, #f8f9fa, #e9ecef)",
          position: "fixed",
          overflowY: "auto",
        }}
      >

        {/* HEADER */}
        <div className="mb-3 text-center">
          <h5 className="fw-bold text-primary mb-0">Dashboard</h5>
          <small className="text-muted">Admin Panel</small>
        </div>

        {/* MENU */}
        <ul className="nav nav-pills flex-column gap-1">

          {/* HOME */}
<li className="nav-item">
  <Link to="/" className="nav-link sidebar-link home-glass">
    <i className="fa fa-house me-2"></i>
    Home
  </Link>
</li>

          {/* ================= FILE ================= */}
          {/*
          <li className="nav-item mt-2">
            <div
              className="nav-link d-flex justify-content-between align-items-center"
              onClick={() => toggleMenu("file")}
              style={{ cursor: "pointer" }}
            >
              <span className="fw-bold text-uppercase text-muted small">
                Fichier
              </span>
              <i className={`fa fa-caret-${openMenu === "file" ? "up" : "down"}`}></i>
            </div>

            {openMenu === "file" && (
              <ul className="ms-3">
                <li><Link to="/" className="nav-link sidebar-link home-glass">Activité Prof</Link></li>
                <li><Link to="/listactivitytype" className="nav-link sidebar-link">Type Activité</Link></li>
                <li><Link to="/listsemploye" className="nav-link sidebar-link">Employé</Link></li>
                <li><Link to="/listsclient" className="nav-link sidebar-link">Client</Link></li>
              </ul>
            )}
          </li>
*/}

{/* ================= FILE ================= */}
<li className="nav-item mt-2 file-glass">

  <div
    className="nav-link d-flex justify-content-between align-items-center file-title"
    onClick={() => toggleMenu("file")}
  >
    <span className="fw-bold text-uppercase small">
      Fichier
    </span>

    <i className={`fa fa-caret-${openMenu === "file" ? "up" : "down"}`}></i>
  </div>

  {openMenu === "file" && (
    <ul className="ms-3 file-submenu">

      <li>
        <Link to="/listactivityprof" className="nav-link sidebar-link home-glass">
          Activité Prof
        </Link>
      </li>

      <li>
        <Link to="/listactivitytype" className="nav-link sidebar-link">
          Type Activité
        </Link>
      </li>


      <li>
        <Link to="/liststatut" className="nav-link sidebar-link">
          Statut Consultant
        </Link>
      </li>

            <li>
        <Link to="/listspecialite" className="nav-link sidebar-link">
          Specialité
        </Link>
      </li>


            <li>
        <Link to="/listwilaya" className="nav-link sidebar-link">
          Wilaya
        </Link>
      </li>

      <li>
        <Link to="/listcommune" className="nav-link sidebar-link">
          Commune
        </Link>
      </li>


    </ul>
  )}
</li>
          {/* ================= CONSULTATION ================= */}


          {/* ================= UTILISATEUR ================= */}
<li className="nav-item mt-2 file-glass">

  <div
    className="nav-link d-flex justify-content-between align-items-center file-title"
    onClick={() => toggleMenu("utilisateur")}
  >
    <span className="fw-bold text-uppercase small">
      Utilisateur
    </span>

    <i className={`fa fa-caret-${openMenu === "utilisateur" ? "up" : "down"}`}></i>
  </div>

  {openMenu === "utilisateur" && (
    <ul className="ms-3 file-submenu">

      <li>
        <Link to="/listusertype" className="nav-link sidebar-link home-glass">
          Type Utilisateur
        </Link>
      </li>

      <li>
        <Link to="/listuserapp" className="nav-link sidebar-link">
          Utilisateur
        </Link>
      </li>


    </ul>
  )}
</li>



        </ul>

        {/* USER */}
        <div className="mt-auto pt-3 border-top">
          <div className="dropdown">
            <button
              className="btn btn-light w-100 dropdown-toggle"
              data-bs-toggle="dropdown"
            >
              <i className="fa fa-user me-2"></i>
              Farid
            </button>

            <ul className="dropdown-menu w-100">
              <li><a className="dropdown-item">Profile</a></li>
              <li><a className="dropdown-item">Settings</a></li>
            </ul>
          </div>
        </div>

      </div>

      {/* CONTENT SPACER */}
      <div style={{ marginLeft: "260px", width: "100%" }} />

    </div>
  );
};

export default SideBar;